/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Empty_Norange_Title2Inputs */

const id_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data dalam rentang ini`)
};

const ms_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada data dalam julat ini`)
};

const da_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data i dette interval`)
};

const de_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Daten in diesem Bereich`)
};

const en_us2_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data in this range`)
};

const es_es2_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos en este rango`)
};

const es_mx2_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos en este rango`)
};

const fil_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang data sa saklaw na ito`)
};

const fr_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée dans cette plage`)
};

const it_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato in questo intervallo`)
};

const hu_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs adat ebben a tartományban`)
};

const nl_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen gegevens in dit bereik`)
};

const no_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data i dette området`)
};

const pl_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych w tym zakresie`)
};

const pt_br2_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dado neste período`)
};

const pt_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dados neste intervalo`)
};

const ro_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fără date în acest interval`)
};

const fi_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tietoja tällä aikavälillä`)
};

const sv_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data i detta intervall`)
};

const vi_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu trong phạm vi này`)
};

const tr_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu aralıkta veri yok`)
};

const cs_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná data v tomto rozsahu`)
};

const bg_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма данни в този диапазон`)
};

const ru_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет данных в этом диапазоне`)
};

const uk_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає даних у цьому діапазоні`)
};

const ar_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد بيانات في هذا النطاق`)
};

const hi_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सीमा में कोई डेटा नहीं`)
};

const th_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีข้อมูลในช่วงนี้`)
};

const ja_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この範囲のデータなし`)
};

const zh_cn2_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该范围内无数据`)
};

const zh_hant1_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此範圍內無資料`)
};

const ko_components_performancetable_empty_norange_title2 = /** @type {(inputs: Components_Performancetable_Empty_Norange_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 기간에 데이터 없음`)
};

/**
* | output |
* | --- |
* | "No data in this range" |
*
* @param {Components_Performancetable_Empty_Norange_Title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_empty_norange_title2 = /** @type {((inputs?: Components_Performancetable_Empty_Norange_Title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Empty_Norange_Title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_empty_norange_title2(inputs)
	if (locale === "ms") return ms_components_performancetable_empty_norange_title2(inputs)
	if (locale === "da") return da_components_performancetable_empty_norange_title2(inputs)
	if (locale === "de") return de_components_performancetable_empty_norange_title2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_empty_norange_title2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_empty_norange_title2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_empty_norange_title2(inputs)
	if (locale === "fil") return fil_components_performancetable_empty_norange_title2(inputs)
	if (locale === "fr") return fr_components_performancetable_empty_norange_title2(inputs)
	if (locale === "it") return it_components_performancetable_empty_norange_title2(inputs)
	if (locale === "hu") return hu_components_performancetable_empty_norange_title2(inputs)
	if (locale === "nl") return nl_components_performancetable_empty_norange_title2(inputs)
	if (locale === "no") return no_components_performancetable_empty_norange_title2(inputs)
	if (locale === "pl") return pl_components_performancetable_empty_norange_title2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_empty_norange_title2(inputs)
	if (locale === "pt") return pt_components_performancetable_empty_norange_title2(inputs)
	if (locale === "ro") return ro_components_performancetable_empty_norange_title2(inputs)
	if (locale === "fi") return fi_components_performancetable_empty_norange_title2(inputs)
	if (locale === "sv") return sv_components_performancetable_empty_norange_title2(inputs)
	if (locale === "vi") return vi_components_performancetable_empty_norange_title2(inputs)
	if (locale === "tr") return tr_components_performancetable_empty_norange_title2(inputs)
	if (locale === "cs") return cs_components_performancetable_empty_norange_title2(inputs)
	if (locale === "bg") return bg_components_performancetable_empty_norange_title2(inputs)
	if (locale === "ru") return ru_components_performancetable_empty_norange_title2(inputs)
	if (locale === "uk") return uk_components_performancetable_empty_norange_title2(inputs)
	if (locale === "ar") return ar_components_performancetable_empty_norange_title2(inputs)
	if (locale === "hi") return hi_components_performancetable_empty_norange_title2(inputs)
	if (locale === "th") return th_components_performancetable_empty_norange_title2(inputs)
	if (locale === "ja") return ja_components_performancetable_empty_norange_title2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_empty_norange_title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_empty_norange_title2(inputs)
	return ko_components_performancetable_empty_norange_title2(inputs)
});
export { components_performancetable_empty_norange_title2 as "components.performanceTable.empty.noRange.title" }